<template>
    <el-table :data="weChatInfoList" stripe style="width: 100%">
        <!-- 公众号信息 是否启用 二维码 链接   :label="activityInfo.title"-->
        <el-table-column header-align="center">
            <el-table-column prop="gzhName" label="公众号信息" width="180">
            </el-table-column>

            <el-table-column prop="ifSend" label="启用发送" width="180">
                <template slot-scope="scope">
                    <el-tooltip :content="scope.row.ifSend == 'true' ? '已启用此活动' : '取消此活动'" placement="top">
                        <el-switch @change="updateIfSend(scope.row)" v-model="scope.row.ifSend" active-color="#13ce66"
                            inactive-color="#ff4949" active-value=true inactive-value=false>
                        </el-switch>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="qrCode" label="活动二维码">
                <template slot-scope="scope">
                    <div class="qrcode" :ref="'qrcode-' + scope.$index" style="margin:50px auto;padding-left: 165px"
                        @click="downloadQrCode(scope.row)"></div>
                </template>
            </el-table-column>
            <el-table-column prop="webUrl" label="活动链接">
                <template slot-scope="scope">
                    <div @click="copyData">
                        <el-link @click="copyData(scope.row)" type="primary">
                            <div v-show="scope.row.webUrl != ''">点击复制链接：</div> {{ scope.row.webUrl }}
                        </el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table-column>

    </el-table>
</template>

<script>
//传入活动信息
//缓存公众号信息
//保存生成的链接

import QRCode from 'qrcodejs2';

export default {
    name: "VoteWechat",
    props: {
        //活动信息
        activityInfo: {
            type: Object,
            default() {
                return {}
            }
        }

    },
    data() {
        return {
            activityId: '',
            activityUrl: '',

            weChatInfoList: [],

        }
    },
    mounted() {
        console.log('VoteWechat mounted', this.$store.state.weChatInfoList)
        console.log('activityInfo', this.activityInfo)

        this.initData();

    },
    created() {

    },
    methods: {


        async initData() {

            await this.getWeChatInfo();

            console.log('initData', this.weChatInfoList)
            if (this.weChatInfoList.length == 0) {
                await this.dealData();
            }

        },
        dealData() {
            return new Promise((resolve, reject) => {
                this.weChatInfoList = this.$store.state.weChatInfoList


                // 循环 this.weChatInfoList 根据id去重 
                let uniqueArray = this.weChatInfoList.filter((item, index) => {
                    return this.weChatInfoList.findIndex(obj => obj.id === item.id) === index;
                });

                this.weChatInfoList = uniqueArray;
                this.weChatInfoList.forEach(info => {
                    // vue对象中没有初始化的属性无法赋值
                    this.$set(info, 'ifSend', false);
                    this.$set(info, 'activityId', this.activityInfo.id);
                    this.$set(info, 'qrCode', '');
                    this.$set(info, 'webUrl', '');
                });

                resolve();
            });


        },

        downloadQrCode(row) {
            // // 获取二维码图片的URL
            // let qrCodeUrl = row.webUrl;
            // // 创建一个a标签
            // let link = document.createElement('a');
            // // 设置a标签的href属性为二维码图片的URL
            // link.href = qrCodeUrl;
            // // 设置a标签的download属性为文件名，这样点击链接时就会下载文件
            // link.download = 'qrcode.png';
            // // 触发a标签的点击事件，实现下载
            // link.click();
        },

        showQrCode(row) {

            this.activityId = this.activityInfo.id
            // this.activityUrl = 'http://192.168.31.102:88/geecityapi/get?appid=wxf014d14d5974b029&type=vote&businessKey='+activity.id
            row.webUrl = 'http://' + row.domainName + '/geecityapi/get?appid=' + row.appId + '&type=vote&businessKey=' + this.activityId;
            this.$nextTick(function () {
                this.creatQrCode(row)
            })
        },

        creatQrCode(row) {
            let index = this.weChatInfoList.indexOf(row);
            console.log('index', index)
            console.log('qrcode', this.$refs['qrcode-' + index])
            let qrcode = new QRCode(this.$refs['qrcode-' + index], {
                text: row.webUrl, // 需要转换为二维码的内容
                width: 120,
                height: 120,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })

        },
        // 点击复制链接
        copyData(row) {
            //如果不需要回调：
            //   this.$copyText(this.activityUrl)
            //如果需要回调：
            this.$copyText(row.webUrl).then(e => {
                this.$message.success("复制成功，请在微信公众号打开！")
            }, function (e) {
                // this.$message.success("复制失败")
            })
        },

        updateIfSend(row) {
            console.log('updateIfSend', row)

            if (row.ifSend == "true") {
                this.showQrCode(row)
            } else {
                row.webUrl = ''
                let index = this.weChatInfoList.indexOf(row);
                let qrcodeElement = this.$refs['qrcode-' + index];
                while (qrcodeElement.firstChild) {
                    qrcodeElement.removeChild(qrcodeElement.firstChild);
                }
            }
            console.log('最终: updateIfSend', this.weChatInfoList)

            this.saveWeChatInfo();
        },
        saveWeChatInfo() {

            const config = {
                headers: {
                    'companyId': encodeURIComponent(this.$store.state.user.companyId),
                    'Content-Type': 'application/json'
                },

            };
            //this.weChatInfoList 转为json
            let weChatInfoListJson = JSON.stringify(this.weChatInfoList);

            this.$axios.post('/admin/activity/saveWeChatInfo/' + this.activityInfo.id,
                weChatInfoListJson, config

            )
                .then(resp => {
                    if (resp && resp.data.code === 200) {
                        // this.getWeChatInfo();
                    }
                })

        },

        getWeChatInfo() {

            return new Promise((resolve, reject) => {
                this.$axios.get('/admin/activity/getWeChatInfoByActivityId/' + this.activityInfo.id,

                )
                    .then(resp => {
                        if (resp && resp.data.code === 200) {
                            console.log("JSON.parse(resp.data.result)", JSON.parse(resp.data.result))

                            this.weChatInfoList = JSON.parse(resp.data.result) == null ? [] : JSON.parse(resp.data.result);
                        }
                        // 请求完成并且 this.weChatInfoList 被更新后，resolve 函数才会被调用。这样，您就可以在其他地方使用 await 关键字等待 getWeChatInfo 方法的执行了。
                        resolve();
                    })

            });



        }

    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/admin/vote/VoteWechat.vue